import { RadioGroup, RadioGroupItem } from '@plato/ui-legacy/components/ui/radio-group';
import { useTranslation } from 'react-i18next';
import type { ExplorerTopLevelEntity } from '../../../server/utils/explorer-utils.ts';
import { allExplorerTabs } from '../../../server/utils/explorer-utils.ts';

type Props = {
    className?: string;
    tabsToShow?: ExplorerTopLevelEntity[];
    selectedTab: ExplorerTopLevelEntity;
    onTabChange: (tab: ExplorerTopLevelEntity) => void;
};

export function ExplorerTopLevelEntityTabs({
    selectedTab,
    onTabChange,
    tabsToShow = allExplorerTabs,
}: Props) {
    const { t } = useTranslation();

    const handleValueChange = (value: string) => {
        onTabChange(value as ExplorerTopLevelEntity);
    };

    return (
        <RadioGroup
            value={selectedTab}
            onValueChange={handleValueChange}
            className="scrollbar-none flex shrink-0 overflow-x-auto"
        >
            {tabsToShow.map((tab) => (
                <RadioGroupItem value={tab} id="option-one" key={tab}>
                    {t(`header_tab__${tab}`, { ns: 'explorer' })}
                </RadioGroupItem>
            ))}
        </RadioGroup>
    );
}
